<sdc-bo-dialog
  headerTitle="Edit all selected events"
  [styleClass]="['variant-prominent-title']">
  <div class="content-wrapper bulk-edit-body">
    <p class="bulk-edit-question">
      Pick the action to apply to all
      <b>{{ eventDescriptions().length }}</b>
      selected events. This is not a text edit — only the event state changes.
    </p>

    <div class="bulk-edit-field">
      <label class="bulk-edit-label" for="bulk-action">Action</label>
      <form [formGroup]="form">
        <select
          id="bulk-action"
          formControlName="action"
          class="bulk-edit-select">
          <option [ngValue]="null" disabled>Choose an action…</option>
          <option value="enable">Enable all selected</option>
          <option value="disable">Disable all selected</option>
          <option value="delete">Delete all selected</option>
        </select>
      </form>
    </div>

    <div class="bulk-edit-field">
      <span class="bulk-edit-label"
        >Selected events ({{ eventDescriptions().length }})</span
      >
      <div class="bulk-edit-events-display">
        @for (description of eventDescriptions(); track description) {
          <div class="bulk-edit-event">{{ description }}</div>
        }
      </div>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss()">Cancel</sdc-button>
    <sdc-button
      variant="primary"
      [disabled]="form.invalid"
      (onClick)="onConfirm()">
      Apply
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
